import React, { useState,useEffect } from 'react'
import { getDocs,collection } from 'firebase/firestore' 
import { firestore } from 'Backend/config'
import Swal from 'sweetalert2';
export default function POE() {
    var [poe,setpoe] = useState([])
    function Back() {
        Swal.fire({
          title: 'Are you sure?',
          text: "Are you sure that you want to go back?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, go back!'
        }).then((result) => {
          if (result.isConfirmed) {
            history.back()
          }
        })
      }
      function open(url){
        Swal.fire({
            imageUrl: url,
          });
    }
    useEffect(() => {
        getDocs(collection (firestore, `Products/POE/POE`)).then((snapshot) => {
          var set = []
          snapshot.docs.forEach((doc) => {
            var data = doc.data()
            data.id = doc.id
            set.push(data)
          })
          setpoe(set)
        })
      },[])
    return (
        <>
        <div className='row' style={{width:'90%',marginLeft: '5%'}}>
        <div className='col-sm-6' style={{marginBottom:'10px',marginTop:'20px'}}>
            <h1>View POE</h1>
        </div>
        <div className='col-sm-6' style={{marginTop:'30px',marginBottom:'20px'}}>
            <button className='btn btn-danger' onClick={()=>{Back()}}>Go Back</button>
        </div>
        </div>
       <table style={{width:'90%',marginLeft: '5%'}}>
      <thead>
        <tr>
          <th scope="col">Model Name</th>
          <th scope="col">Model Price</th>
          <th scope="col">Company</th>
          <th scope="col">POE Size</th>
          <th scope="col">POE Type</th>
          <th scope="col">SFP</th>
          <th scope="col">Link</th>
          <th scope="col">PDF</th>
          <th scope="col">POE Picture</th>
        </tr>
      </thead>
      <tbody>
        <React.Fragment>
        {poe && poe.map((cam2) => {       
             return(<tr key={cam2.id}>
             <td data-label="Model Name">{cam2.Model_Name}</td>
             <td data-label="Model Price">{cam2.Model_Price}</td>
             <td data-label="Company">{cam2.Company}</td>
             <td data-label="POE Size">{cam2.POE_Size}</td>
             <td data-label="POE Type">{cam2.POE_Type}</td>
             <td data-label="SFP">{cam2.SFP?<i className="fa-solid fa-check"></i>:<i className="fa-solid fa-xmark"></i>}</td>
             <td data-label="Link">{cam2.Link?<i className="fa-solid fa-check"></i>:<i class="fa-solid fa-xmark"></i>}</td>
             <td data-label="PDF"><button className="btn btn-primary" onClick={()=>{window.open(cam2.PDF,'_blank')}}>View PDF</button></td>
             <td data-label="PSU Picture"><button className="btn btn-primary" onClick={()=>{open(cam2.POE_Picture)}}>View Image</button></td></tr>)
        })
        }
        </React.Fragment>
      </tbody>
    </table>
        </>
      )
}
